import React, { useEffect, useRef } from "react";
import "../../styles/homePage/table/tableRow.scss";
import { Button, Form } from "react-bootstrap";
import { TableRowBase, TableRowProps } from "../../types/Table.interface";
import Settings from "../../pages/home/Settings";
import { ReactComponent as SettingsIcon } from "../../common/assats/table/settings.svg";
import { ReactComponent as BatteryIcon } from "../../common/assats/icons/batteryGreen.svg";
import { ReactComponent as DeleteIcon } from "../../common/assats/table/trash.svg";
import { ReactComponent as EditIcon } from "../../common/assats/table/edit.svg";
import { ReactComponent as LockIcon } from "../../common/assats/table/lock.svg";
import { ReactComponent as UnlockIcon } from "../../common/assats/table/unlocak.svg";
import { useTranslation } from "react-i18next";
import { formatDateFromISOString } from '../../../src/common/utils/hashUtil'
const TableRow = <T extends TableRowBase>(props: TableRowProps<T>) => {
  const {
    onRowClick,
    checkBoxClick,
    row,
    canEdit,
    canDelete,
    canToggleActive,
    onEditClick,
    onDeleteClick,
    onToggleActionClick,
    extendGapInTable,
    hideCheck
  } = props;
  const [openSettingsRow, setOpenSettingsRow] = React.useState<string | null>(null);
  const { t } = useTranslation();
  const settingsRef = useRef<HTMLDivElement>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const updatedRow = {
      ...row,
      tableProps: {
        ...row.tableProps,
        selected: e.target.checked,
      },
    };

    checkBoxClick && checkBoxClick(updatedRow);
  };

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (settingsRef.current && !settingsRef.current.contains(event.target as Node)) {
        setOpenSettingsRow(null);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleSettings = (rowId: string) => {
    setOpenSettingsRow(prevId => (prevId === rowId ? null : rowId));
  };

  const actions = [
    canEdit && (
      <div key="edit" className="settings-button" onClick={(e) => { e.stopPropagation(); onEditClick?.(row) }}>
        <span>{t("general.buttons.edit")}</span> <EditIcon />
      </div>
    ),
    canDelete && (
      <div key="delete" className="settings-button" onClick={(e) => { e.stopPropagation(); onDeleteClick?.(row) }}>
        <span>{row.tableProps?.isDeleted ? t("general.buttons.restore") : t("general.buttons.delete")}</span> <DeleteIcon />
      </div>
    ),
    canToggleActive && (
      <div key="toggle" className="settings-button" onClick={(e) => { e.stopPropagation(); onToggleActionClick?.(row) }}>
        <span>{t("general.buttons.inactiveActive")}</span>    {row.tableProps?.activeStatus ? <LockIcon /> : <UnlockIcon />}
      </div>
    ),
  ].filter(Boolean);


  const keys = Object.keys(props.row).filter((key) => key !== "tableProps");
  return (
    <div className="table-row-main-container">
      {!hideCheck && <Form.Check
        inline
        id={row.tableProps?.id?.toString()}
        checked={row.tableProps?.selected || false}
        onChange={(e) => { e.stopPropagation(); handleChange(e) }}
      />}

      {keys.map((key, index) => (
        <div
          key={index + key.toLowerCase()} className={`${index===0 ? "table-cell-extend" : index===1 ? "table-cell-extend-150" : "table-cell "}`} title={(row as any)[key]} onClick={() => onRowClick?.(row)}>
          {!key.includes("battery") ? (
            <span className={`${(key.includes("status") || key.includes("Status")) && !key.includes("_") ? "rounded-status" : ""}`}>
              {
                key === 'phoneNumber'
                  ?
                  //if not including + in the phone number, add it
                  (row as any)[key].includes("+") ? (row as any)[key] : "+" + (row as any)[key]
                  :
                  key === 'device_sn' && typeof (row as any)[key] === 'string' && (row as any)[key].includes(',')
                  ?
                  // Show only first device serial number, but tooltip shows all
                  (row as any)[key].split(',')[0].trim()
                  :
                  key !== 'birthday' && key !== 'lastVisit'
                    ?
                    (row as any)[key] ?? "N/A"
                    :
                    (row as any)[key] ? formatDateFromISOString((row as any)[key]) : 'N/A'
              }
            </span>
          ) : (
            <span className="battery-container d-flex align-items-center justify-content-center">
              <span className="battery-icon me-2">
                <BatteryIcon />
              </span>
              {(row as any)[key] ? `${(row as any)[key]}%` : "N/A"}
            </span>
          )}
        </div>
      ))}

      <div className="settings" ref={settingsRef} tabIndex={0}
        onBlur={() => setTimeout(() => setOpenSettingsRow(null), 200)}>
        <SettingsIcon className="settings-icon" onClick={(e) => { e.stopPropagation(); toggleSettings(row.tableProps?.id?.toString() || "") }} />

        {openSettingsRow === row.tableProps?.id?.toString() && (
          <div className="settings-dropdown">
            {actions.map((action, index) => (
              <React.Fragment key={index}>
                {index > 0 && <hr />}
                {action}
              </React.Fragment>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default TableRow;
